import { ChangeDetectionStrategy, Component, computed, input, Signal } from '@angular/core';
import { MuseumCollection } from '../../models/museum-collection.model';
import { ImageComponent } from '@teamfoster/sdk/image';

import { Button, LinkComponent } from '@teamfoster/sdk/button';

import { CookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { IconComponent } from '@teamfoster/sdk/icon';

@Component({
  selector: 'app-museum-collection-card',
  imports: [ImageComponent, LinkComponent, IconComponent],
  templateUrl: './museum-collection-card.component.html',
  styleUrl: './museum-collection-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectionCardComponent {
  collection = input.required<Partial<MuseumCollection>>();
  cookiePreferences = input.required<CookiePreferences | undefined>();
  imageMode = input<'max' | 'crop'>('max');
  intro = input<string | null>();
  hideSubtitle = input<boolean>();

  noLink = computed(() => !this.collection()?.url && !this.button()?.url);

  button = input<Button | null>();

  link: Signal<Button> = computed(() => {
    if (this.button()?.url) {
      return this.button()!;
    }
    if (this.collection()?.url) {
      return {
        url: this.collection()!.url?.join('') || '',
        routerLink: this.collection()!.url!,
        text: this.collection()?.title || '',
        target: '_blank',
      };
    }
    return {
      url: '',
      text: '',
      target: '_blank',
      routerLink: [],
    };
  });
}
